import { render } from "./checkbox_radio.vue?vue&type=template&id=18871df2"
import script from "./checkbox_radio.vue?vue&type=script&lang=js"
export * from "./checkbox_radio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__